export default {
  '--collapse-background': '#303030',
  '--collapse-text-color': '#fff',
  '--collapse-border-top': 'thin solid rgba(255, 255, 255, 0.12)'
};